module.exports = __webpack_public_path__ + "static/media/icon_down_arrow.e5feae6a.svg";